module.exports = __webpack_public_path__ + "img/vehicle-trend-total.06c5ead7.png";